import { render, staticRenderFns } from "./aiEditor.vue?vue&type=template&id=3664ca13&"
import script from "./aiEditor.vue?vue&type=script&lang=js&"
export * from "./aiEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports